import { wait } from "@knowt/syncing/utils/genericUtils";
import useDOMEventListener from "@/hooks/useDOMEventListener";
import { FLASHCARDS_EDITOR_CLASSNAME } from "@/components/flashcards/flashcardsCard/EditableFlashcardCard/constants";
import {
    queryFlashcardTextArea,
    queryEditableFlashcardCard,
} from "@/components/flashcards/flashcardsCard/EditableFlashcardCard/utils";

// TODO - this needs to be refactored: should not query DOM
export const useOnTabPressOnLastFocusedFlashcardCard = (
    lastFlashcardId: string,
    onTabPress: () => Promise<string | null>
) => {
    useDOMEventListener({
        on: "keydown",
        handler: async event => {
            if (event.key !== "Tab") return;
            if (event.shiftKey) return;

            const lastCardElement = queryEditableFlashcardCard(lastFlashcardId);
            const lastCardDefinitionTextArea = queryFlashcardTextArea(lastCardElement);
            const editor = lastCardDefinitionTextArea?.getElementsByClassName("ProseMirror")[0];

            if (editor === document.activeElement) {
                event.preventDefault();
                const flashcardId = await onTabPress();
                if (!flashcardId) return;

                await wait(300);

                const newLastCardElement = queryEditableFlashcardCard(flashcardId);
                if (newLastCardElement) {
                    const defTerm = newLastCardElement.querySelector(`.${FLASHCARDS_EDITOR_CLASSNAME}`);
                    (defTerm?.firstChild as HTMLElement)?.focus();
                }
            }
        },
    });
};
